// Local imports
import classes from "./style.module.css";
import languageConfig from "@/export/config";

export default function Title() {
  return (
    <div className={`${classes.container}`}>
      <h1 className={`${classes.title}`}>
        {languageConfig?.routes.fonts?.main.title}
      </h1>
      <p>{languageConfig?.routes.fonts?.main.description}</p>
    </div>
  );
}
